import { useCallback } from 'react';

export const useEmptyState = (onCreateProject) => {
    const handleCreateProject = useCallback(() => {
        if (onCreateProject) {
            onCreateProject();
        }
    }, [onCreateProject]);

    const handleMoreActions = useCallback(() => {
        // TODO: Implement more actions functionality
        // This could open a dropdown menu with additional options
        console.log('More actions clicked');
    }, []);

    return {
        handleCreateProject,
        handleMoreActions
    };
}; 